"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.map.js");

require("core-js/modules/es6.function.name.js");

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

var _react = _interopRequireDefault(require("react"));

var _SelectField = _interopRequireDefault(require("material-ui/SelectField"));

var _MenuItem = _interopRequireDefault(require("material-ui/MenuItem"));

var _materialUi = require("material-ui");

var _ImageUploader = _interopRequireDefault(require("../shared/elements/imageUpload/ImageUploader"));

require("../../sass/components/internalDash/AddResource.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var fileTypes = ['PDF', 'Video'];
var forValues = [{
  value: 'client',
  name: 'Client-facing'
}, {
  value: 'funeralHome',
  name: 'Funeral Home-facing'
}];

var AddResource = /*#__PURE__*/function (_React$Component) {
  _inherits(AddResource, _React$Component);

  var _super = _createSuper(AddResource);

  function AddResource(props) {
    var _this;

    _classCallCheck(this, AddResource);

    _this = _super.call(this, props);
    _this.state = {
      progress: '',
      fileName: '',
      uploading: false
    };
    _this.handleProgress = _this.handleProgress.bind(_assertThisInitialized(_this));
    _this.handleUploadFinish = _this.handleUploadFinish.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AddResource, [{
    key: "handleProgress",
    value: function handleProgress(progress) {
      this.setState({
        progress: progress
      });
    }
  }, {
    key: "handleUploadFinish",
    value: function handleUploadFinish(url) {
      this.props.handleInputChange('url', 'file')(url);
      this.setState({
        progress: '',
        uploading: false,
        url: url
      });
    }
  }, {
    key: "renderPdfCtrls",
    value: function renderPdfCtrls(progress, resource) {
      var _this2 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "input-row"
      }, !!progress && /*#__PURE__*/_react.default.createElement("p", {
        className: "file-name-text"
      }, 'uploading...  ' + progress + '%'), !!resource.url && /*#__PURE__*/_react.default.createElement("p", {
        className: "file-name-text"
      }, /*#__PURE__*/_react.default.createElement("a", {
        target: "_blank",
        href: resource.url
      }, "Resource Link")), /*#__PURE__*/_react.default.createElement(_ImageUploader.default, {
        show: true,
        acceptedTypes: 'pdf',
        handleProgress: this.handleProgress,
        handleUpload: this.handleUploadFinish,
        ref: function ref(el) {
          return _this2.imageUploader = el;
        },
        label: 'Upload File'
      }));
    }
  }, {
    key: "renderStdCtrl",
    value: function renderStdCtrl(handleInputChange, resource) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "input-row"
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "modal-input full-width",
        placeholder: "Video Url",
        onChange: handleInputChange('url'),
        value: resource.url
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          handleInputChange = _this$props.handleInputChange,
          resource = _this$props.resource;
      var progress = this.state.progress;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "inputs-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "input-row"
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "modal-input full-width",
        placeholder: "Title",
        onChange: handleInputChange('title'),
        value: resource.title,
        required: true
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "input-row"
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "modal-input full-width",
        placeholder: "Caption",
        onChange: handleInputChange('subtitle'),
        value: resource.subtitle,
        required: true
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "input-row"
      }, /*#__PURE__*/_react.default.createElement(_materialUi.Toggle, {
        label: "Feature this Resource?",
        labelPosition: "right",
        defaultToggled: resource.featured,
        onToggle: handleInputChange('featured', 'toggle')
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "input-row"
      }, /*#__PURE__*/_react.default.createElement(_materialUi.Toggle, {
        label: "Activate this Resource?",
        labelPosition: "right",
        defaultToggled: resource.isActive,
        onToggle: handleInputChange('isActive', 'toggle')
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "input-row"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "input-title"
      }, "For"), /*#__PURE__*/_react.default.createElement(_SelectField.default, {
        id: "forFacing",
        placeholder: "For",
        value: resource.forFacing,
        required: true,
        onChange: handleInputChange('forFacing', 'select')
      }, forValues.map(function (forValue) {
        return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
          key: forValue.value,
          value: forValue.value,
          primaryText: forValue.name,
          className: "menu-item"
        });
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "input-row"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "input-title"
      }, "Resource Type"), /*#__PURE__*/_react.default.createElement(_SelectField.default, {
        placeholder: "Resource Type",
        onChange: handleInputChange('filetype', 'select'),
        value: resource.filetype,
        required: true
      }, fileTypes.map(function (fileType) {
        return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
          key: fileType,
          value: fileType,
          primaryText: fileType,
          className: "menu-item"
        });
      }))), resource.filetype === 'PDF' ? this.renderPdfCtrls(progress, resource) : this.renderStdCtrl(handleInputChange, resource))));
    }
  }]);

  return AddResource;
}(_react.default.Component);

exports.default = AddResource;